  <div>
    <div class="modal-header">
      <i class="fa fa-close" (click)="activeModal.close()" style="float:right;"></i>
      <h2 [innerHTML]="helpContent.title"></h2>

    </div>
    <div class="modal-body" [innerHTML]="helpContent.short_text">

    </div>
    <div class="modal-footer">
      <button class="btn btn-default" (click)="activeModal.close()">Close</button>
    </div>
  </div>
